import React, { useState, useRef, useEffect } from 'react';
import styles from './VenueActionsMenu.module.css';

interface VenueActionsMenuProps {
  onEdit: () => void;
  onDelete: () => void;
  onAddLocation: () => void;
  onToggleLocations: () => void;
  onToggleQR: () => void;
  isLocationsExpanded: boolean;
  isQRExpanded: boolean;
}

const VenueActionsMenu: React.FC<VenueActionsMenuProps> = ({
  onEdit,
  onDelete,
  onAddLocation,
  onToggleLocations,
  onToggleQR,
  isLocationsExpanded,
  isQRExpanded
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleMenuToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleAction = (action: () => void) => {
    action();
    setIsOpen(false);
  };

  return (
    <div className={styles.menuContainer} ref={menuRef}>
      <button 
        className={styles.menuButton}
        onClick={handleMenuToggle}
        aria-label="Venue actions menu"
      >
        <span className={styles.dots}>⋯</span>
      </button>
      
      {isOpen && (
        <div className={styles.menuDropdown}>
          <button 
            className={styles.menuItem}
            onClick={() => handleAction(onEdit)}
          >
            Edit
          </button>
          <button 
            className={styles.menuItem}
            onClick={() => handleAction(onDelete)}
          >
            Delete
          </button>
          <button 
            className={styles.menuItem}
            onClick={() => handleAction(onAddLocation)}
          >
            Add Location
          </button>
          <button 
            className={`${styles.menuItem} ${isLocationsExpanded ? styles.active : ''}`}
            onClick={() => handleAction(onToggleLocations)}
          >
            {isLocationsExpanded ? 'Hide' : 'Show'} Locations
          </button>
          <button 
            className={`${styles.menuItem} ${isQRExpanded ? styles.active : ''}`}
            onClick={() => handleAction(onToggleQR)}
          >
            {isQRExpanded ? 'Hide' : 'Show'} QR Code
          </button>
        </div>
      )}
    </div>
  );
};

export default VenueActionsMenu;
